import React from 'react';
import { Helmet } from 'react-helmet';

import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { pageStateHooks } from '../../hooks/pageStateHooks/pageStateHooks';
import { GlobalMessages, PageEntityData } from '../../types/Messages';

export const hooks = {
  useGetStates(): { pageEntity: {
    data: PageEntityData | null;
  } | null; } {
    const pageEntity = messageHooks.useSubjectState(GlobalMessages.PageEntity);
    return {
      pageEntity,
    };
  },
};

export const MetaNotFoundContainer = () => {
  const { entityLoaded } = pageStateHooks.useEntityLoaded();
  const { pageEntity } = hooks.useGetStates();

  if (entityLoaded && !pageEntity?.data) {
    return (
      <Helmet>
        <meta name='prerender-status-code' content='404' />
      </Helmet>
    );
  }

  return null;
};

MetaNotFoundContainer.displayName = 'MetaNotFoundContainer';
